const DateFilterTypes = {
  LAST_MONTH: "last_month",
  LAST_WEEK: "last_week",
  YESTERDAY: "yesterday",
  TODAY: "today",
  CUSTOM: "custom",
} as const;

export default DateFilterTypes;
